import React from "react"
import { useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Box, Typography } from "@material-ui/core"
import ReusableFormControl from "../../../../components/ReusableFormControl"
import MaskedCodeInput from "../../../../components/MaskedCodeInput"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { checkResetPinExists } from "actions/authentication"
import { openSnackBar } from "actions/snack-bar"

const CodeSchema = Yup.object().shape({
  pin: Yup.string()
    .required("Required")
    .length(4, "Pin must be 4 characters long.")
})

const Code = ({ classes, formRef, setWorking, handleStep, setResetData }) => {
  const dispatch = useDispatch()

  const handleSubmit = values => {
    setWorking(true)
    dispatch(checkResetPinExists(values.pin))
      .then(res => {
        if (res.id) {
          setResetData({ id: res.id, pin: values.pin })
          setWorking(false)
          handleStep()
        } else {
          setWorking(false)
          dispatch(openSnackBar({ message: "Incorrect pin." }))
        }
      })
      .catch(error => {
        setWorking(false)
        dispatch(openSnackBar({ message: "Error while checking pin." }))
      })
  }
  return (
    <Box className={classes.codeContainer}>
      <Formik
        innerRef={formRef}
        initialValues={{
          pin: ""
        }}
        validationSchema={CodeSchema}
        onSubmit={values => {
          handleSubmit(values)
        }}
      >
        {formikProps => (
          <Box>
            <Form>
              <Typography>
                A pin has been texted to the phone number entered. Please wait
                to receive the 4 digit pin and enter below.
              </Typography>
              <ReusableFormControl
                name="pin"
                label="Reset Pin"
                formikProps={formikProps}
                inputProps={{
                  inputComponent: MaskedCodeInput,
                  placeholder: "1234",
                  className: classes.pinInput
                }}
              />
            </Form>
          </Box>
        )}
      </Formik>
    </Box>
  )
}

export default withStyles(styles)(Code)



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/steps/Code/index.jsx